import BugReportIcon from '@mui/icons-material/BugReport';
import { Button } from '@mui/material';
import { useReportIssue } from './ReportIssueProvider';

export default function ReportIssueTrigger() {
    const { phase, open } = useReportIssue();

    return (
        <Button aria-label="Report issue" disabled={phase !== 'idle'} onClick={open}>
            <BugReportIcon />
        </Button>
    );
}
